import { useContext, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';

import AnalyticsManager from 'ia-react-core/~/services/analytics/AnalyticsManager';
import AnalyticsContext from '../../components/analytics/#AnalyticsContext';

export interface AnalyticsResult {
  scope: string[];
  track: AnalyticsManager['track'];
  pageView: AnalyticsManager['pageView'];
}

const useAnalytics = () => {
  const location = useLocation();
  const { scope, analytics, values } = useContext(AnalyticsContext);

  const track = useCallback((data: object) => (
    analytics.track({ scope: scope.join(','), values, ...data })
  ), [analytics, scope, values]);

  const pageView = useCallback((data: { pageValues: object }) => {
    analytics.pageView({
      location,
      ...data,
    });
  }, [analytics, location]);

  const analyticsResult: AnalyticsResult = useMemo(() => ({
    scope,
    track,
    values,
    pageView,
  }), [pageView, scope, track, values]);

  return analyticsResult;
};

/**
 * @visibleName useAnalytics
 * @component
 */
export default useAnalytics;
